import React from 'react';

import Box from '@amzn/meridian/box';
import Row from '@amzn/meridian/row';
import Select, { SelectOption } from '@amzn/meridian/select';
import Text from '@amzn/meridian/text';
import _ from 'lodash';
import { type ErrorRecord, type HandleChange } from 'src/hooks/useForm';
import { MeasureUnitAbbreviations, MeasureUnitValues } from 'src/services/tasks/constants';
import { type TaskTableDataRow } from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';

// **** Constants **** //



// **** Types **** //

interface WeightRangeSelectorProps {
  formData: TaskTableDataRow;
  handleChange: HandleChange<TaskTableDataRow>;
  errors: ErrorRecord<TaskTableDataRow>;
}

// **** Components **** //

/**
 * Default component
 */
const WeightRestrictionSelector = (props: WeightRangeSelectorProps) => {
  const { formData, handleChange, errors } = props;

  return (
    <Box>
      <Row spacingInset="400 none">
        <Box>
          <Text color="primary" tag="string">
            For tasks measured in hours you can add a maximum weight to enable task grouping{' '}
          </Text>
          <Text color="secondary" tag="string">
            (Optional)
          </Text>
        </Box>
      </Row>

      <Row widths={['grid-6', 'grid-6']} spacingInset="none none 400 none" alignmentVertical="top">
        {/* Range */}
        <Row widths="fill">
          <Select
            label="Max Weight Restriction"
            placeholder="Select range"
            disabled={!formData.restrictionMaxUnitName}
            value={formData.restrictionMaxValue ?? undefined}
            onChange={(v) => handleChange({ restrictionMaxValue: v })}
            error={errors.restrictionMaxValue?.error}
            errorMessage={errors.restrictionMaxValue?.errorMessage}
          >
            {_.range(2.5, 52.5, 2.5).map((value) => (
              <SelectOption label={value} value={value} key={value} />
            )) ?? []}
          </Select>
        </Row>

        {/* Units */}
        <Row widths="fill">
          <Select
            label="Unit of Measure"
            placeholder="Select units..."
            value={formData.restrictionMaxUnitName ?? undefined}
            onChange={(v) => handleChange({ restrictionMaxUnitName: v === formData.restrictionMaxUnitName ? null : v })}
          >
            <SelectOption
              label={MeasureUnitAbbreviations[MeasureUnitValues.Pounds]}
              value={MeasureUnitValues.Pounds}
              key={MeasureUnitValues.Pounds}
            />
            <SelectOption
              label={MeasureUnitAbbreviations[MeasureUnitValues.Kilograms]}
              value={MeasureUnitValues.Kilograms}
              key={MeasureUnitValues.Kilograms}
            />
          </Select>
        </Row>
      </Row>
    </Box>
  );
};

// **** Export default **** //

export default WeightRestrictionSelector;
